import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'

class CookieModal extends Component {
  constructor() {
    super()
    this.state = {
      show: false
    }
  }

  componentDidMount() {
    try {
      const consent = localStorage.getItem("cookieConsent")
      if (!consent) {
        this.setState({ show: true })
      }
    } catch (e) {
      // Netlify safety
    }
  }

  acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted")
    this.setState({ show: false })
  }

  rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected")
    this.setState({ show: false })
  }

  render() {
    return (
      <Modal
        show={this.state.show}
        onHide={this.rejectCookies}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Cookie Notice</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
We and selected third parties collect personal information and use cookies or similar technologies for technical purposes and with your consent, for functionality, experience, measurement and "marketing (personalized ads)".
          </p>
<p>
Use the "Accept" button to consent. Use the "Reject" button or close this notice to continue without accepting.
            Use the <b>Accept</b> button to consent.
            Use the <b>Reject</b> button or close this notice to continue without accepting.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.rejectCookies}>
            Reject
          </Button>
          <Button variant="dark" onClick={this.acceptCookies}>
            Accept
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default CookieModal
